import React from 'react';
import {View, Text, StyleSheet, FlatList} from 'react-native';
import {availabilityTypeColors} from '../../Utils/paymentUtils';
import { colors} from '@mmt/legacy-commons/Styles/globalStyles';
import Card from '@mmt/legacy-commons/Common/Components/Card';

import {BreakJourneyInterface, BreakJourneySegmentList, BreakJourneyList, BreakJourneySegment} from './BreakJourney.interfaces';
import {parse, format} from 'fecha';
import {rupeeFormatter} from '@mmt/legacy-commons/Helpers/currencyUtils';
import TouchableRipple from '@mmt/legacy-commons/Common/Components/TouchableRipple';
import {initBookBreakJourney} from '../NewListing/RailsListingActions';
import {connect} from "react-redux";
import {
  getISTDateFromIsoDate, getMonthMmm, getTime12HHMM
} from '@mmt/legacy-commons/Common/utils/dateTimeUtil';
import { _label } from '../../vernacular/AppLanguage';
import { fontStyle, getLineHeight } from "../../vernacular/VernacularUtils";

const getDateTime = (dateTimeStr: string) => {
  const jsParsedDate = getISTDateFromIsoDate(dateTimeStr);
  const month = getMonthMmm(jsParsedDate);
  const time = getTime12HHMM(jsParsedDate);
  return {
    date: `${jsParsedDate.getDate()} ${month}`,
    time
  };
};

const formatFloat = (flt: number): number => { // tackeling js floating point gotchas
  const flat = flt.toString().split('.');
  if (flat.length === 1) {
    return flt;
  }
  return Number(`${flat[0]}.${flat[1].slice(0, 2)}`);
}

export const TrainInfoCard = (props) => {
  const data: BreakJourneySegment = props.item;
  const deptDateTime = getDateTime(data.departureTime);
  const arrDateTime = getDateTime(data.arrivalTime);
  // @ts-ignore
  const availabilityColorCode = (availabilityTypeColors[data.availabilityType] || '#000000');

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={[styles.trainInfoStyle, fontStyle("regular"), getLineHeight(12)]}>{data.trainName}</Text>
        <Text style={[styles.trainQuotaStyle, {color: availabilityColorCode, fontSize: 10}, fontStyle("bold"), getLineHeight(10)]}>{data.journeyClass}, {data.prettyPrintingAvailabilityStatus || data.seatsAvailability}</Text>
      </View>
      <View style={styles.row}>
        <Text style={[styles.trainInfoTimeStyle, fontStyle("black"), getLineHeight(12)]}>{deptDateTime.time}, <Text style={[styles.trainInfoStyle, fontStyle("regular")]}>{deptDateTime.date}</Text></Text>
        <Text style={[styles.trainInfoTimeStyle, fontStyle("black"), getLineHeight(12)]}>{arrDateTime.time}, <Text style={[styles.trainInfoStyle, fontStyle("regular")]}>{arrDateTime.date}</Text></Text>
      </View>
      <View style={styles.row}>
        <Text style={[styles.trainInfoStyle, fontStyle("regular"), getLineHeight(12)]}>{data.sourceStationName}</Text>
        <Text style={[styles.trainInfoStyle, fontStyle("regular"), getLineHeight(12)]}>{data.destinationStationName}</Text>
      </View>
      {data.confirmationChance && <View style={{...styles.row, flexDirection: 'row-reverse'}}>
        <Text style={{color: '#33d18f', fontSize: 12}}>{ _label("confirmation_chances", undefined, {
          percent: data.confirmationChance.toString(),
        })}</Text>
      </View>}
    </View>
  );
};

const TrainOptionCard = (props) => {
  const breakJourneyData : BreakJourneyInterface = props.item;
  const {index} = props;
  const noOfTrains = breakJourneyData.segmentList.length;
  let totalFare = 0;
  for (const segment of breakJourneyData.segmentList) {
    totalFare += segment.segmentFare;
  }
  const totalFareFormatted = formatFloat(totalFare);
  const cardStyle = {
    backgroundColor: colors.white,
    borderRadius: 8,
    borderColor: colors.lightGrey,
    padding: 16,
    borderWidth: 0.5,
    marginBottom: 13
  };

  return (

    <Card style={cardStyle} elevation={2}>
      <TouchableRipple onPress={() => {
        props.initBookBreakJourney(breakJourneyData);
      }}>

        <View>
        <View style={styles.headingContainer}>
          <View style={{flex: 1, flexDirection: 'row'}}>
            <Text style={[styles.optionHeading, fontStyle("black"), getLineHeight(16)]}>{ _label("option", undefined, { num: (index + 1).toString() })}</Text>
            <Text style={[styles.optionSubHeading, fontStyle("black"), getLineHeight(12)]}> { _label("with_count_trains", undefined, { count: noOfTrains.toString()})}</Text>
          </View>
          <Text style={[styles.optionHeading, fontStyle("black"), getLineHeight(12)]}>{`₹ ${rupeeFormatter(totalFareFormatted)}`}</Text>
        </View>
        <FlatList
          data={breakJourneyData.segmentList}
          renderItem={item => <TrainInfoCard {...item} />}
          ItemSeparatorComponent={(props) => {
            const leadingItem: BreakJourneySegment = props.leadingItem;
            return <SeparatorWithTitle title={_label("change_train_at_station", undefined, {station: leadingItem.destinationStationName})} />;
  }}
        />
        </View>
      </TouchableRipple>
    </Card>
  );
};

export const SeparatorWithTitle = (props) => {
  const {title} = props;
  return (
    <View style={styles.layoverContainer}>
      <View style={styles.separatorStyle} />
      <View style={styles.layoverTextContainer}>
        <Text style={[styles.layoverStyle, fontStyle("bold"), getLineHeight(12)]}>{title}</Text>
      </View>
    </View>
  );
};


const AlternateBreakJourneyCard = (props: BreakJourneyList) => (
  <View style={styles.alternateCardContainer} testID={props?.id}>
    <Text style={[styles.header, fontStyle("black"), getLineHeight(20)]}>{_label("alternate_train_options")}</Text>
    <Text style={[styles.subheader, fontStyle("bold"), getLineHeight(14)]}>{_label("consider_break_journey_trains")}</Text>
    <FlatList
      data={props.breakJourneyList}
      renderItem={item =>
        <TrainOptionCard {...item} initBookBreakJourney={props.initBookBreakJourney}  />}
    />
  </View>
);

const styles = StyleSheet.create({
  alternateCardContainer: {
    backgroundColor: '#f5fefb',
    padding: 16,
    paddingTop: 20
  },
  header: {
    fontSize: 20,
    color: colors.black
  },
  subheader: {
    fontSize: 14,
    color: colors.defaultTextColor,
    lineHeight: 20,
    marginBottom: 15
  },
  headingContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  container: {

    marginVertical: 16,
    marginTop: 10
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5
  },
  separatorStyle: {
    height: 0.5,
    borderColor: colors.lightGrey,
    borderWidth: 0.5,
    borderStyle: 'dashed',
    borderRadius: 1,
    marginBottom: 15,
    alignSelf: 'stretch',
    width: '100%'
  },
  layoverStyle: {
    fontSize: 12,
    color: colors.defaultTextColor,
    textAlign: 'center',
    paddingHorizontal: 8
  },
  layoverTextContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.lightGrey,
    borderRadius: 8.5,
    position: 'absolute',
    top: -7
  },
  layoverContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  optionHeading: {
    fontSize: 16,
    color: colors.black
  },
  optionSubHeading: {
    fontSize: 12,
    margin: 4,
    color: colors.lightTextColor
  },
  trainInfoStyle: {
    fontSize: 12,
    lineHeight: 12,
    color: colors.lightTextColor,
    textTransform: 'capitalize'
  },
  trainInfoTimeStyle: {
    fontSize: 12,
    lineHeight: 12,
    color: colors.black
  },
  trainQuotaStyle: {
    fontSize: 10,
    lineHeight: 10
  }
});

const mapStateToProps = (state, ownProps) => {
  return {...ownProps};
};
const mapDispatchToProps = (dispatch) => ({
  initBookBreakJourney: (breakJourneyRequest) => {
    dispatch(initBookBreakJourney(breakJourneyRequest));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AlternateBreakJourneyCard);
